import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import delete_Vector from "../utils/delete_Vector.jpg";
import Drawer from "./Drawer";
import LeadStageModal from "../modals/LeadStageModal";
import expand from "../utils/expand.png";
import { useNavigate } from "react-router-dom";
import { useBreadcrumbs } from "../modals/BreadcrumbsContext";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { format } from "date-fns";

const QualifiedGrouped = ({
  // openStatusModal,
  stageMapping,
  deleteSelectedLeads,
  // showDeleteModal,
  calculateAgedDays,
  // viewLead,
  filteredQualifiedLeadRows,
  // groupedQualifiedLeads,
  selectedLeads,
  setSelectedLeads,
  // closeDeleteModal,
  // selectedLead,
  // handleSave,
  // handleInputChange,
  rows,
  setRows,
  history,
}) => {
  // const [selectedLeads, setSelectedLeads] = useState([]); // State to track selected leads
  const [showDrawer, setShowDrawer] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showStageModal, setShowStageModal] = useState(false);
  const [discoveryLeads, setDiscoveryLeads] = useState(
    JSON.parse(localStorage.getItem("discoveryLeads")) || [] // Initialize from localStorage if available
  );

  const [wonLeads, setWonLeads] = useState(
    JSON.parse(localStorage.getItem("wonLeads")) || [] // Initialize from localStorage if available
  );

  const [lostLeads, setLostLeads] = useState(
    JSON.parse(localStorage.getItem("lostLeads")) || [] // Initialize from localStorage if available
  );

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false); // Close modal
  };

  const openStatusModal = (lead) => {
    setSelectedLead(lead);
    setShowStageModal(true);
  };

  const closeStatusModal = () => {
    setShowStageModal(false);
  };

  const groupedQualifiedLeads = filteredQualifiedLeadRows?.reduce(
    (groups, lead) => {
      // const stage = lead.stage || "Unknown";
      const stage = lead.stage || "new";
      if (!groups[stage]) {
        groups[stage] = [];
      }
      groups[stage].push(lead);
      return groups;
    },
    {}
  );

  // console.log('groupedQualifiedLeads::::::::',groupedQualifiedLeads)

  const viewLead = (id) => {
    const lead = groupedQualifiedLeads.new.find((lead) => lead.lead_id === id);
    console.log(lead); // Log or return the lead you found
    setSelectedLead(lead);
    setShowDrawer(true); // Show Drawer
  };

  useEffect(() => {
    // const lead = rows.find((lead) => lead.id === id);
    // console.log("useEffect selectedLead:",selectedLead)
  }, [selectedLead]);

  const updateStageToWon = (leadId) => {
    // Find the lead to update
    const leadToMoveWon = rows.find((row) => row.lead_id === leadId);
    if (!leadToMoveWon) return; // Guard against invalid ID

    // Create a new timeline entry for the status change to "Won"
    const currentTimestamp = new Date().toISOString(); // Get the current timestamp
    const statusChangeTimeline = {
      date: currentTimestamp,
      activity: "Stage changed to Won",
    };

    // Ensure timeline exists and is an array, then add the new activity
    const updatedQualifiedLeadWon = {
      ...leadToMoveWon,
      stage: "won", // Update stage to won
      timeline: Array.isArray(leadToMoveWon.timeline)
        ? [...leadToMoveWon.timeline, statusChangeTimeline] // Add the new timeline entry
        : [statusChangeTimeline], // If no timeline, create a new array with the status change
    };

    // Update the rows state and remove the updated lead from rows
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((row) => row.lead_id !== leadId);
      // console.log("updatedRows", updatedRows);
      // Save updated rows to localStorage
      //localStorage.setItem("qualifiedLeads", JSON.stringify(updatedRows));
      return updatedRows; // Update state with the filtered rows
    });

    // Add the updated lead to the wonLeads list
    const updatedWonLeads = [...wonLeads, updatedQualifiedLeadWon];
    setWonLeads(updatedWonLeads);
    // console.log("updatedWonLeads", updatedWonLeads);

    // Save updated wonLeads to localStorage
    localStorage.setItem("wonLeads", JSON.stringify(updatedWonLeads));

    // Close the modal
    setShowStageModal(false);
  };

  const updateStageToLost = (leadId) => {
    // Find the lead to update
    const leadToMoveLost = rows.find((row) => row.lead_id === leadId);
    if (!leadToMoveLost) return; // Guard against invalid ID

    // Update the lead's stage to "lost"
    const updatedQualifiedLeadLost = { ...leadToMoveLost, stage: "lost" };

    // Update the rows state and remove the updated lead
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((row) => row.lead_id !== leadId);
      // console.log("updatedRows", updatedRows);

      // Save updated rows to localStorage
      //localStorage.setItem("qualifiedLeads", JSON.stringify(updatedRows));
      // localStorage.setItem("lostLeads", JSON.stringify(updatedRows));

      return updatedRows; // Update state with the filtered rows
    });

    // Add the updated lead to the wonLeads list
    const updatedLostLeads = [...lostLeads, updatedQualifiedLeadLost];
    setLostLeads(updatedLostLeads);
    // console.log("updatedLostLeads", updatedLostLeads);

    // Save updated discoveryLeads to localStorage
    localStorage.setItem("lostLeads", JSON.stringify(updatedLostLeads));

    // Close the modal
    setShowStageModal(false);
  };

  const updateLeadStage = (leadId, newStage) => {
    console.log("Updating lead stage:", { leadId, newStage });

    // Find and update the lead in rows
    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) =>
        row.lead_id === leadId ? { ...row, stage: newStage } : row
      );
      console.log("updatedRows", updatedRows);

      // Save updated rows to localStorage
      // localStorage.setItem("qualifiedLeads", JSON.stringify(updatedRows));
      //, JSON.stringify(updatedRows));
      return updatedRows;
    });

    // 24-2-2025====================================
    // // Update groupedQualifiedLeads to reflect the new stage
    // setFilteredQualifiedGroupedRows((prevLeads) => {
    //   const updatedLeads = { ...prevLeads };

    //   // Find the old stage group and remove the lead
    //   for (const [stage, leads] of Object.entries(updatedLeads)) {
    //     const leadIndex = leads.findIndex((lead) => lead.id === leadId);
    //     if (leadIndex !== -1) {
    //       // Remove the lead from the current stage group
    //       const [lead] = leads.splice(leadIndex, 1);

    //       // Add the lead to the new stage group
    //       if (!updatedLeads[newStage]) updatedLeads[newStage] = [];
    //       updatedLeads[newStage].push({ ...lead, stage: newStage });

    //       break;
    //     }
    //   }

    //   return updatedLeads;
    // });
    // 24-2-2025====================================

    // Close the modal after updating
    closeStatusModal();
  };

  const stageOrder = [
    "new",
    "discovery",
    "proposal",
    "negotiation",
    "won",
    "lost",
  ];

  const { showBreadcrumbs, setShowBreadcrumbs } = useBreadcrumbs();

  const [filteredQualifiedGroupedRows, setFilteredQualifiedGroupedRows] =
    useState({});

  const [qualifiedLeads, setQualifiedLeads] = useState([]);
  // const [qualifiedLeads, setQualifiedLeads] = useState(
  //   JSON.parse(localStorage.getItem("qualifiedLeads"))?.map((lead) => ({
  //     ...lead,
  //     stage: lead.stage ?? "new",
  //   })) || []
  // );
  useEffect(() => {
    // const grouped = rows?.reduce((acc, lead) => {
    const grouped = qualifiedLeads?.reduce((acc, lead) => {
      if (!acc[lead.stage]) acc[lead.stage] = [];
      acc[lead.stage].push(lead);
      return acc;
    }, {});

    const sortedGroupedQualifiedLeads = Object.keys(grouped ?? {})
      .sort((a, b) => stageOrder.indexOf(a) - stageOrder.indexOf(b))
      ?.reduce((sorted, key) => {
        sorted[key] = grouped[key];
        return sorted;
      }, {});

    setFilteredQualifiedGroupedRows(sortedGroupedQualifiedLeads);
  }, [rows]);

  // debugging 24-1-25
  // useEffect(() => {
  //   console.log("Rows updated:", rows);
  // }, [rows]);

  // useEffect(() => {
  //   console.log("Grouped Leads updated:", filteredQualifiedGroupedRows);
  // }, [filteredQualifiedGroupedRows]);

  const navigate = useNavigate();

  const [quoteLeadId, setQuoteLeadId] = useState("");

  const handleQuoteButtonClick = (leadId) => {
    setQuoteLeadId(leadId);
    console.log("handleQuoteButtonClick = (leadId):", leadId);
    navigate(`/qualifiedLeadsTable/quoteLead/${leadId}`);
    if (setShowDrawer) setShowDrawer(false);
    setShowBreadcrumbs(true);
  };

  const handleInputChange = (e, field) => {
    // console.log("clicked from grouped qualified!!");
    setSelectedLead((prevLead) => ({
      ...prevLead,
      [field]: e.target.value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();

    const updatedLead = { ...selectedLead };

    // Flatten the grouped structure into a single array
    const allLeads = Object.values(filteredQualifiedGroupedRows).flat();

    // Find the original lead
    const originalLead = allLeads.find((lead) => lead.id === selectedLead.id);

    if (!originalLead) {
      console.error("Original lead not found.");
      return;
    }

    let isChanged = false; // Track if any field has changed
    const updatedHistory = [...(updatedLead.history || [])]; // Ensure history exists

    // Detect and log changes
    Object.keys(updatedLead).forEach((field) => {
      const oldValue = originalLead[field];
      const newValue = updatedLead[field];
      if (oldValue !== newValue) {
        updatedHistory.push({
          date: new Date().toISOString(),
          activity: `Field "${field}" updated`,
          note: `Changed from "${oldValue}" to "${newValue}"`,
        });
        isChanged = true;
      }
    });

    if (isChanged) {
      updatedLead.history = updatedHistory;
    }

    // Update the grouped structure
    const updatedGroupedLeads = { ...filteredQualifiedGroupedRows };
    Object.keys(updatedGroupedLeads).forEach((stage) => {
      updatedGroupedLeads[stage] = updatedGroupedLeads[stage].map((lead) =>
        lead.id === selectedLead.id ? updatedLead : lead
      );
    });

    setFilteredQualifiedGroupedRows(updatedGroupedLeads); // Update state
    // localStorage.setItem(
    //   "qualifiedLeads",
    //   JSON.stringify(Object.values(updatedGroupedLeads).flat())
    // );

    setShowDrawer(false); // Close the drawer
  };

  const location = useLocation();
  // const selectedQuotationDate = location.state?.selectedDate || "";
  const selectedQuotationDate = location.state?.formattedDate || "";
  // console.log("location.state:", location.state);
  // console.log("selectedQuotationDate:", selectedQuotationDate);
  const isQuotationRoute = location.pathname.includes("quoteLead");

  useEffect(() => {

    console.log("selectedLeads ", selectedLeads)

  }, [selectedLeads])

  const splitText = (stringReceived) => {

    console.log("stringReceived ", stringReceived)

    let n = 10; // insert a character after every 5 characters
    let insertChar = "\n";
    let outputString = stringReceived.split(",")

    return (outputString)

  }

  const arrangeSalesPersonNameArray = (arrayToBeOrdered) => {


    console.log("arrayToBeOrdered ", arrayToBeOrdered)

    let newArray = arrayToBeOrdered.map((textToBeEdited) => {

      if (textToBeEdited.includes("@")) {

        return "Email : " + textToBeEdited

      } else if (!isNaN(textToBeEdited.replace(/\s/g, ""))) {
        return "Mob : " + textToBeEdited
      } else {
        return textToBeEdited
      }

    })

    let mobObject = newArray.filter((itemFilter) => {
      return itemFilter.includes("Mob")
    })

    let emailObject = newArray.filter((itemFilter) => {
      return itemFilter.includes("@")
    })


    let nameObject = newArray.filter((itemFilter) => {
      return !itemFilter.includes("@") && !itemFilter.includes("Mob")
    })

    console.log("arrayToBeOrdered newArray mobObject", newArray, mobObject, emailObject)

    return [nameObject, mobObject, emailObject]


  }

  return (
    <div className="overflow-x-auto  ">
      {selectedLeads?.length > 0 && (
        <div className="mb-2">
          <button
            // onClick={deleteSelectedLeads}
            onClick={handleDelete}
            className="bg-red-500 text-white px-2 py-2 rounded mr-2"
            disabled={selectedLeads?.length === 0}
          >
            <AiFillDelete size={18} />
          </button>
        </div>
      )}
      {console.log("groupedQualifiedLeads::", groupedQualifiedLeads)}
      {Object.entries(groupedQualifiedLeads).map(([stage, leads]) => (
        <div key={stage} className="mb-6">
          <h2 className="text-lg font-thin mb-2">
            {stageMapping[stage] || stage} Leads ({leads?.length})
          </h2>
          <table className="table-auto w-full border-collapse border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="shadow-sm px-1 py-0.5 w-[20px] text-left">
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow"
                    onChange={(e) =>
                      setSelectedLeads(
                        e.target.checked ? leads.map((row) => row.lead_id) : []
                      )
                    }
                    checked={
                      selectedLeads?.length > 0 &&
                      leads.every((row) => selectedLeads.includes(row.lead_id))
                    }
                  />
                </th>

                <th className="shadow-sm px-1 py-0.5  text-left font-normal w-[100px]">
                  Lead ID
                </th>
                <th className="shadow-sm px-1 py-0.5  text-left font-normal w-[200px]" style={{ whiteSpace: "nowrap" }}>
                  Date
                </th>
                <th className="shadow-sm px-1 py-0.5  text-left font-normal w-[300px]">
                  SalesPerson
                </th>

                <th className="shadow-sm px-1 py-0.5 w-[380px] text-left font-normal">
                  Customer / Organization
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[100px] text-left font-normal">
                  Stage
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[100px] text-left font-normal">
                  Project
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[100px] text-left font-normal">
                  Contact Person
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[100px] text-left font-normal">
                  Title
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[150px] text-left font-normal ellipsis">
                  Email
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[100px] text-left font-normal">
                  Phone
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[150px] text-left font-normal">
                  Entry Location
                </th>
                <th className="shadow-sm px-1 py-0.5 w-[50px] text-left font-normal">
                  Probability
                </th>
              </tr>
            </thead>
            <tbody className="bg-white px-2">
              {leads.map((row) => (
                <tr
                  key={row.lead_id}
                  className={`${selectedLeads.includes(row.lead_id) ? "bg-blue-100" : ""
                    }`}
                >
                  {console.log("row id is ", row)}
                  <td className="shadow-sm px-1 py-0.5 w-[20px] text-left">
                    <div className="flex justify-between items-center w-auto">
                      <input
                        type="checkbox"
                        className="rounded border border-sm"
                        checked={selectedLeads.includes(row.lead_id)}
                        onChange={() =>
                          setSelectedLeads((prev) =>
                            prev.includes(row.lead_id)
                              ? prev.filter((id) => id !== row.lead_id)
                              : [...prev, row.lead_id]
                          )
                        }
                      />
                      {row?.Cnt > 0 && (
                        <div className="w-1 h-1 bg-green-500 text-xs p-1 rounded-lg"></div>
                      )}
                    </div>
                  </td>


                  <td className="shadow-sm px-1 py-0.5 w-[100px] ">
                    <div>
                      {row.lead_id}
                    </div>
                  </td>
                  <td className="shadow-sm px-1 py-0.5 w-[200px] " style={{ whiteSpace: "nowrap" }}>
                    <div>
                      {
                        format(row.lead_entryTime, "dd-MM-yyyy")}
                    </div>
                  </td>

                  <td className="shadow-sm px-1 py-0.5 w-[300px] ">
                    <div>

                      {row.lead_salespersonName
                        ?
                        arrangeSalesPersonNameArray(splitText(row.lead_salespersonName
                        )) ?
                          arrangeSalesPersonNameArray(splitText(row.lead_salespersonName
                          ))[0]
                          : "--"
                        :
                        "--"
                      }
                    </div>
                  </td>

                  <td className="shadow-sm px-1 py-0.5 w-[380px]">
                    <div className="flex items-start justify-between gap-2">
                      {/* <div>{row.lead_primarycontact}</div> */}
                      {row.lead_organization}


                      {row.lead_teamid !== "0" ?
                        <div style={{
                          backgroundColor: "#000000",
                          borderRadius: "17px",
                          padding: "2px 10px",
                          color: "#ffffff",
                          fontSize:"12px"
                        }}>
                          {row.lead_teamid}
                        </div> : null
                      }


                      <div className="flex items-center  justify-center gap-2">
                        <img
                          onClick={() => viewLead(row.lead_id)}
                          src={expand}
                          alt="expand-icon"
                          className="w-4 h-4 cursor-pointer"
                        />
                        <div className="text-xs font-thin bg-gray-400 px-0.5 rounded-lg text-white">
                          {calculateAgedDays(row.lead_entryTime)}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td
                    className={`shadow-sm px-1 py-0.5 w-[100px] cursor-pointer`}
                  // onClick={() => openStatusModal(row)}
                  >
                    {row.lead_stage && (
                      <button
                        className={`w-full text-white text-center p-1 rounded ${row.lead_stage === "new" ? "bg-yellow-500" //
                          : row.lead_stage === "discovery"
                            ? "bg-teal-500" //
                            : row.lead_stage === "proposal"
                              ? "bg-sky-500" //
                              : row.lead_stage === "negotiation"
                                ? "bg-orange-600" //
                                : row.lead_stage === "won"
                                  ? "bg-green-600" //
                                  : row.lead_stage === "lost"
                                    ? "bg-red-600" //
                                    : "bg-blue-500" //
                          }`}
                      >
                        {stageMapping[row.lead_stage] || row.lead_stage}{" "}
                      </button>
                    )}
                  </td>
                  <td>
                    <div>{row.lead_CampaignId}</div>
                  </td>
                  <td className="shadow-sm px-1 py-0.5 w-[100px]">
                    {/* {row.lead_organization} */}
                    <div>{row.lead_primarycontact}</div>
                  </td>
                  <td className="shadow-sm px-1 py-0.5 w-[100px]">
                    {row.lead_primarycontacttitle}
                  </td>
                  <td className="shadow-sm px-1 py-0.5 w-[150px]">
                    {row.lead_email}
                  </td>
                  <td className="shadow-sm px-1 py-0.5 w-[100px] text-center">
                    {row.lead_phone}
                  </td>
                  <td className="shadow-sm px-1 py-0.5 w-[150px] text-ellipsis ">
                    {row.lead_assignedto?.length > 0 ? <a href={`http://maps.google.com/?q=${row.lead_assignedto}`}>View</a> : "" }
                    
                  </td>
                  <td className="shadow-sm px-1 py-0.5  w-[50px] text-center ">
                    {row.lead_probability}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Delete Confirmation Modal */}
          {showDeleteModal && selectedLeads.length > 0 && (
            <div className="fixed inset-0 z-50 flex justify-center items-center  ">
              <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center relative">
                {/* Image Section */}
                <div className="flex justify-center mb-2">
                  <img
                    src={delete_Vector}
                    alt="Delete Icon"
                    className="w-1/2 h-auto max-w-xs"
                  />
                </div>

                {/* Close Button */}
                <button
                  className="absolute top-6 right-8 text-gray-500 hover:text-black"
                  onClick={closeDeleteModal}
                >
                  ✖
                </button>

                {/* Title Section */}
                <div className="text-xl font-semibold text-black">
                  {selectedLeads?.length === 1
                    ? "Lead Selected"
                    : "Leads Selected"}
                </div>
                <div className="text-gray-700 mb-6">
                  {/* Display different message based on the number of selected rows */}
                  {selectedLeads?.length === 1 ? (
                    <span className="font-bold">
                      {/* Are you sure you want to delete {checkedLead}{" "} */}
                      Are you sure you want to delete ?
                    </span>
                  ) : (
                    <span className="font-bold">
                      Are you sure you want to delete {selectedLeads?.length}{" "}
                      leads?
                    </span>
                  )}
                </div>

                {/* Action Buttons */}
                <div className="flex justify-center space-x-4">
                  {/* Delete Button */}
                  <button
                    className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                    onClick={deleteSelectedLeads} // Call delete function
                  >
                    Delete
                  </button>

                  {/* Cancel Button */}
                  <button
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                    onClick={closeDeleteModal}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Modal Dialog for select stage */}
          {showStageModal && selectedLead && (
            <LeadStageModal
              closeStatusModal={closeStatusModal}
              updateStageToWon={updateStageToWon}
              updateStageToLost={updateStageToLost}
              selectedLead={selectedLead}
              updateLeadStage={updateLeadStage}
            // updateStageToDiscovery={updateStageToDiscovery}
            />
          )}

          {/* {showDrawer && ( */}
          <Drawer
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
            selectedLead={selectedLead}
            handleInputChange={handleInputChange}
            handleSave={handleSave}
            rows={rows}
            setRows={setRows} // Passing state and updater function
            leadsWithHistory={history}
            stageMapping={stageMapping}
            handleQuoteButtonClick={handleQuoteButtonClick}
            setShowBreadcrumbs={setShowBreadcrumbs}
          // updatedLead.leadHistory
          // leadTimeline={selectedLead.leadTimeline}
          />
          {/* )} */}
        </div>
      ))}
    </div>
  );
};

export default QualifiedGrouped;
